<template>
    <appHeader> </appHeader>
   <!-- banner section -->
   <transition name="fade">
   <section class="w3l-banner pt-5" :class="background" >
        <div class="container" style="margin-top: 100rpx;">
            <div class="row">
                <div class="col-xl-6 banner-left" style="margin-top:15rem">
                    <!-- <h3 class="text-white mb-3 title">Ensuring every <br>
                        <span class="type-js"><span class="text-js">lost pet </span></span>makes it home safely</h3>
                    <p class="lead text-white">Empowering pet identification with QR code and NFC technology
                    </p> -->
                    <div class="d-flex align-items-center mt-5">
                        <a class="btn btn-style-white mr-2" href="/product">需要标签吗？购买标签</a>
                        <a class="btn btn-style-white btn-style-border" href="#">有标签？点击激活</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </transition>
    <!-- //banner section -->

    <!-- about section -->
    <!-- <section class="w3l-features-photo-7 py-5">
        <div class="container py-md-5 py-4">
            <div class="row w3l-features-photo-7_top align-items-center">
                <div class="col-lg-6 w3l-features-photo-7_top-right mb-lg-0 mb-sm-5 mb-4">
                    <img src="@/assets/images/about.jpg" class="img-responsive" alt="" />
                </div>
                <div class="col-lg-6 w3l-features-photo-7_top-left pl-lg-4">
                    <h4 class="title-style mb-2">About Us</h4>
                    <p>Orci urna. In et augue ornare,
                        tempor massa in,
                        luctus sapien.
                        Proin a diam et dui fermentum dolor molestie vel id neque. Donec sed tempus enim, a congue
                        risus. Pellen
                        tesqu.
                    </p>
                    <div class="row feat_top mt-4 pt-lg-3">
                        <div class="col-6 w3l-features-photo-7-box">
                            <i class="fa fa-paw" aria-hidden="true"></i>
                            <h5 class="w3l-feature-text my-2">Our Mission</h5>
                            <p>In a diam et dui elit, orci urna vel id neque. Donec sed tempus enims.</p>
                        </div>
                        <div class="col-6 w3l-features-photo-7-box">
                            <i class="fa fa-angellist" aria-hidden="true"></i>
                            <h5 class="w3l-feature-text my-2">Our Vision</h5>
                            <p>Et dui elit, orci urnavel id neque. Donec in a diam sed tempus trsma.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- //about section -->

    <!-- what we do section -->
    <div class="w3l-grids-block-5 py-5">
        <div class="container pb-md-5 py-4">
            <div class="row justify-content-center text-center">
                <div class="col-md-8">
                    <div class="section-heading mb-sm-5 mb-4">
                        <h3 class="title-style mb-2">我们可以做</h3>
                        <p class="lead lead-desc">
                            连接的不只是标签，而是回家的路。
                        </p>
                        <p class="lead lead-desc">
                            还有更多贴心功能，为爱守护
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, index) in whatwedo" :key="index" class="col-lg-4 col-md-6 mt-md-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img :src="'/static/images/'+item.picDir" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">{{ item.picTitleCn }}</a></h4>
                                <p>{{ item.picDescCn }}</p>
                            </div>
                        </div>
                    </div>
                </div>
<!--
                <div class="col-lg-4 col-md-6 mt-md-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img src="@/assets/images/img1.jpg" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">Safe retrieval system</a></h4>
                                <p>Pets lost without panic, scanning code to contact the owner, improve the efficiency of retrieval</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-md-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img src="@/assets/images/img2.jpg" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">Smart platform support</a></h4>
                                <p>Web page one key registration, update information at any time.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-lg-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img src="@/assets/images/img3.jpg" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">Location records</a></h4>
                                <p>Real-time records of the geographic location of the code, fast tracking pet trajectory</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-lg-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img src="@/assets/images/img2.jpg" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">Security</a></h4>
                                <p>Data encryption and privacy protection</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 mt-lg-0 mt-4">
                    <div class="blog-card-single">
                        <div class="grids5-info">
                            <a href="#"><img src="@/assets/images/img3.jpg" alt="" /></a>
                            <div class="blog-info">
                                <h4><a href="#">No need for App</a></h4>
                                <p>Data encryption to protect the owner's information</p>
                            </div>
                        </div>
                    </div>
                </div>
    -->
            </div>
        </div>
        
    </div>
    <!-- //what we do section -->

    <!-- data section -->
    <section class="w3l-aboutblock py-5">
        <div class="container py-lg-5 py-md-4 py-2">
            <!-- <div class="row"> -->
                <div class="about-right-faq align-self pr-xl-5">
                    <h3 class="title-style mb-2">关键宠物数据，一眼看懂我们的价值</h3>
                    <p class="mt-3 p-fsize" >在全球范围内，宠物陪伴着数亿家庭，但数据背后，也隐藏着宠物走失与流浪的严峻现实。我们的使命，是用科技守护每一个毛孩子的归途。</p>
                        
                </div>
                <div class="about-right-faq align-self pr-xl-5">
                    <h3 class="title-style mb-2 mt-5">全球宠物现状</h3>
                    <img src="@/assets/images/zzt.jpg" alt="World Map" class="map-img">
                    <p class="mt-3 p-fsize" >全球宠物数量：10亿+
                        流浪宠物总量：超2亿只（持续增长中）
                        每年走失宠物比例：65%以上
                        每分钟，就有数十只宠物在全球范围内走失。
                    </p>
                </div>
                <div class="about-right-faq align-self pr-xl-5">
                    <h3 class="title-style mb-2 mt-5">宠物找回率对比</h3>
                    <p class="mt-3 p-fsize" >配备身份ID标签的宠物有80%+找回成功率，但是无id身份标识的宠物找回率不足20%。
                        身份标签，大大提高找回成功率，是每只宠物的“安全保障”。</p>
                        
                       
                </div>
                <div class="about-right-faq align-self pr-xl-5">
                     <img src="@/assets/images/ditudw.jpg" alt="World Map" class="map-img">
                    <h3 class="title-style mb-2 mt-5">我们的服务足迹</h3>
                    <p class="mt-3 p-fsize" >已覆盖国家和地区：30+<br>
                    支持多语言平台、全球扫码可用 <br>
                    服务持续扩展中，致力于打造全球宠物安全网络</p>
                </div>
                <div class="about-right-faq align-self pr-xl-5">
                    <h3 class="title-style mb-2 mt-5">❤为什么这些数据重要？</h3>
                    <p class="mt-3 p-fsize" >这些数字，不只是冷冰冰的统计。它们提醒我们——宠物的安全，不能依靠运气。
而我们，正在用科技与责任，为它们创造一个更有保障的世界。</p>
                </div>
            <!-- </div> -->
        </div>
    </section>
    <!-- //customers section -->

    <!-- gallery section -->
    <div class="gallery section-agile py-5">
        <div class="container py-md-5 py-4">
            <div class="row justify-content-center text-center" style="box-sizing: border-box;">
                <h3 class="title-style mb-2">宠物失踪与寻回</h3>
                <div style="width:100%;display: flex;flex-direction:column;align-items: center;justify-content: center;min-height:300px">
                    <div style="width: 100%;height: 60px;background: #FFF;display: flex;align-items: center;">
                        <div style="width: 50%;display: flex;flex-direction: column;align-items: center;justify-content: center;font-weight: bolder;"> <h4> 《我的宠物丢了》</h4></div>
                       
                        <div style="width: 50%;display: flex;flex-direction: column;align-items: center;justify-content: center;font-weight: bolder;"> <h4>《我发现宠物》</h4></div>
                    </div>
                    <div style="width: 100%;min-height: 60px;background: #fff;display: flex;">
                        <div style="width: 50%;height:160px;display: flex;flex-direction: column;align-items: center;">
                            <div style="width: 100%;display: flex;flex-direction: column; font-size: 20px;">
                                <p style="color:#000;font-size:16px">当宠物走失时，向社区报告这一情况会让人感到害怕</p> 
                                <p style="color:#000;font-size:16px">但当您需要帮助时，我们有社区和资源为您提供支持。</p>
                            </div>
                            <div style="width: 100%;display: flex;flex-direction: column;height:200px;align-items: center;justify-content: center;">
                                <a style="width:150px;border:none;border-radius: 30px;height:30px;background-color: #FF9600;color:#fff;font-size: 15px;line-height: 30px;" href="/#">报告失踪</a>
                            </div>
                        </div>
                        <div style="width: 50%; height:160px;display: flex;flex-direction: column;align-items: center;">
                            <div style="width: 100%;display: flex;flex-direction: column;font-size: 20px;">
                                <p style="color:#000;font-size:16px">如果您发现了一个身份标识牌，</p> 
                                <p style="color:#000;font-size:16px">请扫描下面的二维码来查找宠物。</p>
                            </div>
                            <div style="width: 100%;display: flex;flex-direction: column;height:200px;align-items: center;justify-content: center;">
                                <a style="width:150px;border:none;border-radius: 30px;height:30px;background-color: #FF9600;color:#fff;font-size: 15px;line-height: 30px;" href="/#">现在报告</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row gallery_grids" style="margin-top:10px" v-if="missingfound && missingfound.length > 0">           
                <img :src="'/static/images/'+missingfound[0].picDir" alt=" " class="img-fluid" />
            </div>
        </div>
    </div>
    <!-- //gallery section -->
  </template>
  
  <script>
  import appHeader from '@/components/appHeader.vue';
  export default {
    name: 'appHome', 
    components: {
      appHeader
    }
  }
  </script>
  <script setup>
import api from '@/assets/js/requests';
import { onMounted, onUnmounted, ref } from 'vue';
    const background = ref('w3l-banner-background3')
    const backgroundImageStyles = ref([])
    const currentImageIndex = ref(0);
    const intervalId = ref(null);
    const whatwedo =ref([]);
    const missingfound = ref([]);
    onMounted(async () => {
        const expireTime = localStorage.getItem('cacheExpire');
        if (expireTime && Date.now() > parseInt(expireTime)) {
            localStorage.removeItem('cachedHomePics');
            localStorage.removeItem('cacheExpire');
        }
        getHomePics().then( res =>{
            generateDynamicStyles(res);
            if (intervalId.value) {
                clearInterval(intervalId.value);
            }
            if(backgroundImageStyles.value.length === 1){
                background.value = backgroundImageStyles.value[currentImageIndex.value];
                return;
            }
           intervalId.value = setInterval(() => {
                if(backgroundImageStyles.value.length > 0){
                    background.value = backgroundImageStyles.value[currentImageIndex.value]
                    currentImageIndex.value = (currentImageIndex.value + 1) % backgroundImageStyles.value.length;
                    return;
                }
                if (background.value === 'w3l-banner-background2') { 
                    background.value = 'w3l-banner-background3'
                } else {
                    background.value = 'w3l-banner-background2'
                }
            }, 5000);
        })
        getWhatwedoPics().then( res =>{
            whatwedo.value = res
        })
        getMissingFoundPics().then( res =>{
            missingfound.value = res
            console.log("miss", res)
        })  
    })

    // 获取首页图片数据
    const getHomePics = () => {
        return new Promise((resolve, reject) => { 
            try {
                const cachedPics = localStorage.getItem('cachedHomePics');
         
                if (cachedPics) {
                    resolve(JSON.parse(cachedPics));
                    return;
                }
                console.log(11111)
                api.home.getHomePics().then(res => {
                    if (res.data && res.data.data.length > 0) {
                        const pictures = res.data.data;
                        // 动态生成CSS样式
                        localStorage.setItem('cachedHomePics', JSON.stringify(pictures));
                        localStorage.setItem('cacheExpire', Date.now() + 86400000);
                        resolve(pictures);
                        return;
                    }
                    resolve();
                });
            } catch (err) {
                // 即使API失败，也继续使用默认背景
                reject(err);
            } 
        });
    };

    const getWhatwedoPics = () => {
        return new Promise((resolve, reject) => {
            try {
                const cachedPics = localStorage.getItem('whatwedoPics');
                if (cachedPics) {
                    resolve(JSON.parse(cachedPics));
                    return;
                }
                api.system.getSystemPics('1').then(res => {
                    if (res.data && res.data.data.length > 0) {
                        localStorage.setItem('whatwedoPics', JSON.stringify(res.data.data));
                    }
                    resolve(res.data.data);
                })
            }catch(err){
                reject(err);
            }
        })
    };

    const getMissingFoundPics = () => { 
        return new Promise((resolve, reject) => {
             try {
                 const cachedPics = localStorage.getItem('missingfoundPics');
                if (cachedPics) {
                    resolve(JSON.parse(cachedPics));
                    return;
                }
                api.system.getSystemPics('2').then(res => {
                    console.log(res.data.data)
                    if (res.data && res.data.data.length > 0) {
                        localStorage.setItem('missingfoundPics', JSON.stringify(res.data.data));
                    }
                    resolve(res.data.data);
                })
            }catch (error) {
                reject(error);
            }
        })      
    };

    // 动态生成CSS样式
    const generateDynamicStyles = (pictures) => {
        if(!pictures || pictures.lengthg <= 0  ){
            return
        }
        // 创建或更新动态样式
        let styleElement = document.getElementById('dynamic-backgrounds');
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'dynamic-backgrounds';
            document.head.appendChild(styleElement);
        }

        let cssRules = '';
        var transion = pictures.length > 0 ? "transition: background-image 2s ease-in-out;" : ""
        pictures.forEach((imageData, index) => {

            cssRules += `
                .dynamic-background-${index} {
                    width:100%;
                    display:flex;
                    background-image: url('/static/images/${imageData.picDir}') !important;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    -webkit-background-size: cover;
                    -moz-background-size: cover;
                    -o-background-size: cover;
                    -ms-background-size: cover;
                    ${transion}
                }
            `;
            backgroundImageStyles.value.push("dynamic-background-" + index);
        });
        styleElement.textContent = cssRules;
    };

    onUnmounted(() => {
        // 清理定时器
        stopBackgroundRotation();
        
        // 清理动态样式
        const styleElement = document.getElementById('dynamic-backgrounds');
        if (styleElement) {
            styleElement.remove();
        }
    });

    // 停止背景轮播
    const stopBackgroundRotation = () => {
        if (intervalId.value) {
            clearInterval(intervalId.value);
            intervalId.value = null;
        }
    };

 </script>
  
  <style lang="css">
  /* 可以添加样式 */
  .p-fsize{
    font-size: 20px;
    color:#000;
  }
  .map-img {
      float: right;
      max-width: 40%;
      height: auto;
      margin: 0 0 20px 20px;
      display: block;
      border-radius: 5px; /* 图片圆角 */
      /* box-shadow: 0 4px 8px rgba(0,0,0,0.1); */ /*图片阴影 */
    }
    .lead-desc{
        font-weight: bold;
    }
  </style>